import React, { useState, useCallback, useMemo, useContext } from 'react';
import moment from 'moment';
import { SORT_BY_STRING } from '@ubeya/shared/utils/sorting';
import { API_TIME_FORMAT } from '@ubeya/shared/constants';
import DropDown from '../../DropDown';
import CheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';
import ConfigContext from '../../../contexts/ConfigContext';

const ProjectLiveViewStartTimeFilter = ({
  slug,
  defaultValue,
  handleClose,
  onApply,
  search,
  onChange,
  externalOptions = {},
  hideLayout = false
}) => {
  const { t, timeFormat } = useContext(ConfigContext);
  const [values, setValues] = useState(defaultValue || []);

  const startTimeOptions = (externalOptions[slug] || [])
    .map(({ id, value }) => ({
      value: id,
      label: moment(value, API_TIME_FORMAT).format(timeFormat)
    }))
    .sort(SORT_BY_STRING('label'));

  const handleChange = useCallback(
    (value) => {
      const newValues = values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
      setValues(newValues);
      onChange?.(newValues);
    },
    [onChange, values]
  );

  const filteredOptions = useMemo(
    () =>
      search
        ? (startTimeOptions || []).filter(
            ({ label }) =>
              t('startTime').toLowerCase().includes(search.toLowerCase()) ||
              label.toLowerCase().includes(search.toLowerCase())
          )
        : startTimeOptions,
    [startTimeOptions, search, t]
  );

  if (!filteredOptions.length) {
    return null;
  }

  return (
    <FilterLayout
      name={t('startTime')}
      handleClose={handleClose}
      onApply={() => onApply(values)}
      hideLayout={hideLayout}>
      {filteredOptions.map(({ value, label }) => (
        <DropDown.Item key={value}>
          <CheckBox
            name={`startTime-${value}`}
            value={values.includes(value)}
            label={label}
            onChange={() => handleChange(value)}
          />
        </DropDown.Item>
      ))}
    </FilterLayout>
  );
};

export default ProjectLiveViewStartTimeFilter;
